import RadioButton from 'components/formComponents/Base/RadioButton';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAppDispatch } from '../../../../../hooks';
import { ApplicantRole } from '../../../../../types/PartyApplication/partyApplication';
import { setApplicantRole } from '../../../../../redux/reducer/partyApplicationSlice';
import { StartSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type props = {
  texts?: StartSectionTexts;
};

const ApplicantRoleSelect = ({ texts }: props) => {
  const dispatch = useAppDispatch();
  const watch = useFormContext().watch;
  const selectedRole = watch('applicantRole');
  useEffect(() => {
    if (selectedRole !== undefined && selectedRole !== null) {
      dispatch(setApplicantRole(selectedRole));
    }
  }, [selectedRole, dispatch]);

  return (
    <>
      <RadioButton
        header={texts?.applicantRoleSubHeadline ?? 'Min roll'}
        name="applicantRole"
        options={[
          {
            id: String('applicant-role-' + ApplicantRole.companyRepresentative),
            value: ApplicantRole.companyRepresentative,
            displayValue:
              texts?.companyRepresentative?.label ?? 'Företagsrepresentant',
            sortOrder: texts?.companyRepresentative?.radioSortOrder ?? 1,
          },
          {
            id: String('applicant-role-' + ApplicantRole.unionRepresentative),
            value: ApplicantRole.unionRepresentative,
            displayValue:
              texts?.unionRepresentative?.label ?? 'Facklig representant',
            sortOrder: texts?.unionRepresentative?.radioSortOrder ?? 2,
          },
        ]}
      />
    </>
  );
};

export default ApplicantRoleSelect;
